/* global module, require */
const THREE = require('three'),
	typeface = require('../res/montserrat-subset.json'),
	unit = require('./unit');

const arrowWidth = unit.cm(5),
	boxHeight = unit.cm(10),
	grid = unit.m(1),
	square = unit.cm(40),
	textOffset = unit.cm(10);

const arrowMat = new THREE.MeshBasicMaterial({
	color: 0x2b245b,
	opacity: 0.5,
	transparent: true,
});

function AddTool(planner, measurements) {
	this.planner = planner;
	this.measurements = measurements;

	this.mesh = new THREE.Mesh(
		new THREE.BoxBufferGeometry(square, boxHeight, square).translate(
			0,
			boxHeight / 2,
			0
		),
		arrowMat
	);
	this.raycaster = new THREE.Raycaster();
	this.active = false;

	this.plane = new THREE.Mesh(
		new THREE.PlaneBufferGeometry(1000, 1000).rotateX(-Math.PI / 2),
		new THREE.MeshBasicMaterial({ visible: false })
	);
	this.correction = new THREE.Vector3(grid / 2, 0, grid / 2);

	this.aline = new THREE.Mesh().rotateZ(Math.PI / 2);
	this.aline.material = arrowMat;

	this.atext = new THREE.Mesh();
	this.atext.material = new THREE.MeshBasicMaterial({ color: 0 });
	this.arrow = new THREE.Group().add(this.aline).add(this.atext);

	this.font = new THREE.Font(typeface);

	this.move = this.move.bind(this);
	this.click = this.click.bind(this);
}

AddTool.prototype.toggle = function() {
	if (this.active) this.stop();
	else this.start();
};

AddTool.prototype.start = function() {
	this.active = true;

	this.planner.scene.add(this.mesh);
	this.planner.scene.add(this.arrow);
	this.planner.element.addEventListener('mousemove', this.move, false);
	this.planner.element.addEventListener('mousedown', this.click, false);
};

AddTool.prototype.stop = function() {
	this.active = false;

	this.planner.scene.remove(this.mesh);
	this.planner.scene.remove(this.arrow);
	this.planner.element.removeEventListener('mousemove', this.move);
	this.planner.element.removeEventListener('mousedown', this.click);
};

AddTool.prototype.getMousePosition = function(e) {
	const { width, height } = this.planner;
	var mouse = new THREE.Vector2();

	mouse.x = (e.offsetX / width) * 2 - 1;
	mouse.y = -(e.offsetY / height) * 2 + 1;

	return mouse;
};

AddTool.prototype.getIntersection = function(mouse, objects) {
	this.raycaster.setFromCamera(mouse, this.planner.camera);
	return this.raycaster.intersectObjects(objects);
};

AddTool.prototype.move = function(e) {
	const mouse = this.getMousePosition(e);
	const intersects = this.getIntersection(mouse, [this.plane]);
	if (intersects.length > 0) {
		const intersect = intersects[0];
		const destination = new THREE.Vector3()
			.copy(intersect.point)
			.add(intersect.face.normal)
			.add(this.correction)
			.divideScalar(grid)
			.floor()
			.multiplyScalar(grid);

		this.mesh.position.copy(destination);
		this.updateArrow(destination);
	}
};

AddTool.prototype.updateArrow = function(destination) {
	const { position } = this.measurements.getLastPosition();
	const between = new THREE.Vector3().copy(destination).sub(position);
	const middle = new THREE.Vector3()
		.copy(between)
		.divideScalar(2)
		.add(position);
	const length = between.length();
	const showLength = Math.round(unit.mmReverse(length));

	if (this.length !== length) {
		this.aline.geometry.dispose();
		this.aline.geometry = new THREE.BoxBufferGeometry(
			arrowWidth,
			length,
			arrowWidth
		);
		this.aline.position.copy(middle);
		this.aline.rotation.y = Math.PI / 2 + Math.atan2(between.x, between.z);

		this.atext.geometry.dispose();
		this.atext.geometry = new THREE.TextBufferGeometry(`${showLength}mm`, {
			font: this.font,
			size: 4,
			height: 1,
			curveSegments: 3, // reduce resource usage a bit
		});
		this.atext.position.copy(destination);
		this.atext.position.y += textOffset;
		this.atext.lookAt(this.planner.camera.position);
	}
};

AddTool.prototype.click = function(e) {
	if (e.button === 0) {
		this.measurements.addAt(this.mesh.position);
		this.move(e);
	}
};

module.exports = AddTool;
